import * as net from '~/lib/net';
import { getToken } from '~/apps/shared/services/token';
import { UserEndpoints } from './endpoints';
import { User } from '../models';
import * as schemas from './schemas';


/********************************************
 *************  V2 version  *****************
 ********************************************/

export async function getUserById(userId: string): Promise<User> {
  const data = await net.apiGet(UserEndpoints.getUserById(userId), getToken());
  return schemas.UserSchema.load(data);
}


export async function getOrgUsers(filter = null, offset: number, limit: number): Promise<User[]> {
  const data = await net.apiGet(UserEndpoints.getOrgUsers(filter, offset, limit), getToken());
  return schemas.UserListSchema.load(data);
}

// Updating
export interface UserCreateRequest {
  username: string;
  organizationId: string;
  password: string;
  role: string;
  locationId: string;
  departmentId: string;
  shift: string;
  email?: string;
  firstName?: string;
  lastName?: string;
}

export interface UserUpdateRequest {
  role: string;
  password?: string;
  email?: string;
  locationId?: string;
  departmentId?: string;
  shift?: string;
  firstName?: string;
  lastName?: string;
}

export async function createUser(req: UserCreateRequest) {
  const payload = schemas.UserChangeRequest.save(req);

  const data = await net.apiPost(UserEndpoints.createUser(), getToken(), payload);
  return schemas.UserSchema.load(data);
}

export async function updateUser(userId: string, req: UserUpdateRequest) {
  const payload = schemas.UserChangeRequest.save(req);

  const data = await net.apiPost(UserEndpoints.updateUser(userId), getToken(), payload);
  return schemas.UserSchema.load(data);
}

export async function deleteUser(userId: number) {
  const data = await net.apiDelete(UserEndpoints.deleteUser(userId), getToken());
  return schemas.UserSchema.load(data);
}
